module.exports = __webpack_public_path__ + "assets/audio.81e33379bfa2fe3732b4ec43f0890b22.gif";